import { render } from "./PDO3Rapat.vue?vue&type=template&id=54439b22"
import script from "./PDO3Rapat.vue?vue&type=script&lang=js"
export * from "./PDO3Rapat.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__